import { Menu } from 'lucide-react';
import logoMark from '../assets/logo/relate-ai-rainbow-spiral-logo-mark.jpg';
import { navItems } from '../data/content';

export default function Navbar() {
  return (
    <header className="sticky top-0 z-50 border-b border-white/50 bg-white/70 backdrop-blur-2xl">
      <nav className="section-container flex min-h-20 items-center justify-between" aria-label="Primary navigation">
        <a href="#top" className="flex items-center gap-3 font-extrabold tracking-tight" aria-label="Relate.ai home">
          <img src={logoMark} alt="Relate.ai rainbow spiral logo" className="h-10 w-10 rounded-2xl object-cover shadow-glass" />
          <span className="text-xl">Relate<span className="gradient-text">.ai</span></span>
        </a>
        <div className="hidden items-center gap-8 text-sm font-semibold text-slate-600 lg:flex">
          {navItems.map((item) => <a key={item.href} href={item.href} className="transition hover:text-violet-700">{item.label}</a>)}
        </div>
        <div className="hidden items-center gap-3 lg:flex">
          <a className="secondary-button min-h-10 px-5 py-2" href="#early-access">Sign In</a>
        </div>
        <button className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-violet-100 bg-white/75 text-violet-700 shadow-glass lg:hidden" aria-label="Open navigation menu">
          <Menu size={22} aria-hidden="true" />
        </button>
      </nav>
    </header>
  );
}
